import { render, staticRenderFns } from "./AdminComponent.vue?vue&type=template&id=be0cd480&scoped=true"
import script from "./AdminComponent.vue?vue&type=script&lang=js"
export * from "./AdminComponent.vue?vue&type=script&lang=js"
import style0 from "./AdminComponent.vue?vue&type=style&index=0&id=be0cd480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0cd480",
  null
  
)

export default component.exports